<!-- 教育o2o -->
<template>
  <div class="warp">
    <div class="educationBanner">
      <p>绿茶教育O2O系统</p>
      <span>线上课程引流扩客/线下培训会务管理</span>
      <a class="button-text" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
    </div>
    <div class="education1">
      <div class="title">线上线下联动，高效实现引流增量</div>
      <ul>
        <li>
          <img src="../../assets/images/page06.jpg" />
          <span>活动管理</span>
        </li>
        <li>
          <img src="../../assets/images/page07.jpg" />
          <span>社群营销</span>
        </li>
        <li>
          <img src="../../assets/images/page08.jpg" />
          <span>线下拓客</span>
        </li>
        <li>
          <img src="../../assets/images/page09.jpg" />
          <span>课程销售</span>
        </li>
        <li>
          <img src="../../assets/images/page10.jpg" />
          <span>引流拓客</span>
        </li>
        <li>
          <img src="../../assets/images/page11.jpg" />
          <span>数据管理</span>
        </li>
      </ul>
      <div style="padding-top:.8rem">
        <img src="../../assets/images/page12.jpg" alt srcset />
      </div>
    </div>
    <div class="education2">
      <div class="title">
        <span>活动管理</span>
        <p>多维数据分析，实时掌控活动流程</p>
        <img src="../../assets/images/page13.jpg" />
      </div>
      <div class="con">
        <b class="first">+</b>
        <b class="last">+</b>
        <ul>
          <li>轻松创建活动，搭配活动模块一键搞定</li>
          <li>报名数据统计，抢先预见活动情况</li>
          <li>到场扫码核销，支持线上报名，线下签到</li>
          <li>互动玩法多样，提高用户活跃度</li>
        </ul>
      </div>
    </div>

    <div class="education2">
      <div class="title">
        <span>社群营销</span>
        <p>完善的社群管理体系，多渠道客源集中沉淀</p>
        <img src="../../assets/images/page14.jpg" />
      </div>
      <div class="con">
        <b class="first">+</b>
        <b class="last">+</b>
        <ul>
          <li>支持课程关联，购买课程即可进群</li>
          <li>设置社群专属优惠，吸引普通用户进群</li>
          <li>群公告，消息置顶，抢先预告活动亮点</li>
          <li>群动态及成员管理，社群管理更轻松</li>
        </ul>
      </div>
    </div>

    <div class="education2 education3">
      <div class="title">
        <span>社群营销</span>
        <p>完善的社群管理体系，多渠道客源集中沉淀</p>
      </div>
      <div class="conts">
        <div class="item">
          <img src="../../assets/images/page16.jpg" />
          <p>
            现场录播转课程
            <br />打造活动专栏二次引流
          </p>
        </div>
        <div class="item">
          <img src="../../assets/images/page17.jpg" />
          <p>
            现场互动专属优惠
            <br />引导购买课程
          </p>
        </div>
      </div>
      <div class="itemRow">
        <img src="../../assets/images/page18.jpg" />
        <p>
          现场互动专属优惠
          <br />引导购买课程
        </p>
      </div>
    </div>

    <div class="education2">
      <div class="title">
        <span>课程销售</span>
        <p>多种主流变现形式，满足各行业需求</p>
      </div>
      <div class="course">
        <ul>
          <li>
            <img src="../../assets/images/icon01.png" />
            <span>付费课程</span>
          </li>
          <li>
            <img src="../../assets/images/icon02.png" />
            <span>付费直播</span>
          </li>
          <li>
            <img src="../../assets/images/icon03.png" />
            <span>付费问答</span>
          </li>
        </ul>
        <div class="itemCen">
          <img src="../../assets/images/page19.jpg" alt srcset />
        </div>
        <ul>
          <li>
            <img src="../../assets/images/icon04.png" />
            <span>付费会员</span>
          </li>
          <li>
            <img src="../../assets/images/icon05.png" />
            <span>付费社群</span>
          </li>
          <li>
            <img src="../../assets/images/icon06.png" />
            <span>付费活动</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="education2">
      <div class="title">
        <span>课程销售</span>
        <p>多种主流变现形式，满足各行业需求</p>
      </div>
      <div class="course" style="padding:0">
        <div class="itemCen">
          <img src="../../assets/images/page20.jpg" alt srcset />
        </div>
      </div>
    </div>

    <div class="education2 education4">
      <div class="title">
        <span>数据管理</span>
        <p>数据复盘总结 实现精准营销及二次营销</p>
      </div>
      <div class="information">
        <ul>
          <li>
            <span>消费数据</span>
            <p>
              <i></i>用户消费数据分析，总结消费特点
            </p>
          </li>
          <li>
            <span>交易数据</span>
            <p>
              <i></i>活动现场交易数据统计 计算当场活动收益
            </p>
          </li>
          <li>
            <span>流量统计</span>
            <p>
              <i></i>活动后新流量统计 复盘活动效果
            </p>
          </li>
          <li>
            <span>点评系统</span>
            <p>
              <i></i>教师点评系统及评价收集剖析讲师授课效果
            </p>
          </li>
          <li>
            <span>拉新数据</span>
            <p>
              <i></i>老用户拉新数据收集推广效果一手掌握
            </p>
          </li>
          <li>
            <span>报表导出</span>
            <p>
              <i></i>多维数据一键导出形成报表效率更高
            </p>
          </li>
        </ul>
      </div>
    </div>

    <div class="education2 education5">
      <div class="title">
        <span>应用场景</span>
      </div>
      <div class="scene">
        <ul>
          <li>
            <img src="../../assets/images/icon07.png" />
            <span>金融理财</span>
          </li>
          <li>
            <img src="../../assets/images/icon08.png" />
            <span>母婴课堂</span>
          </li>
          <li>
            <img src="../../assets/images/icon09.png" />
            <span>语言培训</span>
          </li>
          <li>
            <img src="../../assets/images/icon10.png" />
            <span>学历提升</span>
          </li>
          <li>
            <img src="../../assets/images/icon11.png" />
            <span>兴趣爱好</span>
          </li>
          <li>
            <img src="../../assets/images/icon12.png" />
            <span>职业技能</span>
          </li>
          <li>
            <img src="../../assets/images/icon13.png" />
            <span>医疗讲座</span>
          </li>
          <li>
            <img src="../../assets/images/icon14.png" />
            <span>更多</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="education2">
      <div class="title">
        <span>客户案例</span>
      </div>
      <div class="course" style="padding:0">
        <div class="itemCen">
          <img src="../../assets/images/page22.gif" alt srcset />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "education",

  data() {
    return {};
  },
  mounted() {},

  methods: {}
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .educationBanner {
    background: url("../../assets/images/education_banner.jpg") no-repeat left
      top;
    background-size: 100% auto;
    height: 7rem;
    text-align: center;
    color: #fff;
    padding-top: 2.2rem;
    p {
      font-size: 0.64rem;
      padding-bottom: 0.3rem;
    }
    span {
      font-size: 0.48rem;
      display: block;
      padding-bottom: 1rem;
    }
    a {
      width: 3.2rem;
      height: 1rem;
      color: #fff;
      font-size: 0.36rem;
      background-color: #00ac83;
      border-radius: 1rem;
      outline: none;
      line-height: 1rem;
      text-align: center;
      display: block;
    }
  }
  .education1 {
    padding-top: 1rem;
    text-align: center;
    .title {
      font-size: 0.48rem;
    }
    ul {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
      li {
        width: 33.33333%;
        margin-top: 0.9rem;
        img {
          width: 2rem;
        }
        span {
          display: block;
          font-size: 0.4rem;
        }
      }
    }
  }
  .education2 {
    .title {
      padding-top: 1rem;
      text-align: center;
      span {
        font-size: 0.52rem;
      }
      p {
        padding-top: 0.1rem;
        font-size: 0.36rem;
      }
      img {
        width: 100%;
      }
    }
    .course {
      display: flex;
      padding: 0.7rem 0 0.1rem;
      ul {
        flex: 1;
        padding: 0 0.4rem;
        li {
          height: 1.2rem;
          line-height: 1.2rem;
          background-color: #f3f9f2;
          font-size: 0.36rem;
          margin-bottom: 0.17rem;
          display: flex;
          align-items: center;
          img {
            width: 0.4rem;
            margin: 0 0.2rem 0 0.4rem;
            margin-top: -0.06rem;
          }
        }
      }
      .itemCen {
        flex: 1;
      }
    }
    .con {
      padding: 0 0.5rem;
      position: relative;
      b {
        position: absolute;
        font-size: 0.7rem;
        color: #50704e;
        font-weight: 400;
        opacity: 0.6;
      }
      .first {
        left: 0.3rem;
        top: -0.4rem;
      }
      .last {
        right: 0.3rem;
        bottom: -0.4rem;
      }
      ul {
        margin-top: 0.3rem;
        li {
          font-size: 0.36rem;
          height: 1rem;
          line-height: 1rem;
          background-color: #f2f9f1;
          padding-left: 0.5rem;
          margin-bottom: 0.2rem;
        }
      }
    }
  }
  .education3 {
    background: url("../../assets/images/page15.jpg") no-repeat top center #fff;
    background-size: 100% auto;
    margin-top: 1rem;
    padding-top: 0.5rem;
    .title {
      color: #fff;
    }
    .conts {
      display: flex;
      padding: 0 0.2rem;
      padding-top: 0.8rem;
      .item {
        background-color: #fff;
        box-shadow: 0px 0px 0.3rem 0px rgba(47, 78, 55, 0.3);
        border-radius: 0.1rem;
        width: 48%;
        margin: 0 1%;
        text-align: center;
        padding-top: 0.6rem;
        img {
          width: 3rem;
        }
        p {
          font-size: 0.4rem;
          line-height: 0.6rem;
          display: block;
          padding: 0.3rem 0 0.5rem;
        }
      }
    }
    .itemRow {
      display: flex;
      align-items: center;
      background-color: #fff;
      box-shadow: 0px 0px 0.3rem 0px rgba(47, 78, 55, 0.3);
      border-radius: 0.1rem;
      width: 94%;
      margin: 0.3rem auto;
      padding: 0.3rem;
      img {
        width: 3rem;
        margin: 0 0.4rem;
      }
      p {
        font-size: 0.48rem;
        line-height: 0.7rem;
      }
    }
  }
  .education4 {
    background: url("../../assets/images/page21.jpg") no-repeat center center;
    background-size: 100% auto;
    height: 10.8rem;
    .information {
      padding: 0 0.75rem;
      ul {
        li {
          display: flex;
          height: 0.8rem;
          margin-top: 0.5rem;
          line-height: 0.8rem;
          span {
            font-size: 0.4rem;
            width: 2.1rem;
          }
          p {
            background-color: #00b389;
            color: #fff;
            font-size: 0.32rem;
            flex: 1;
            padding: 0 0.3rem;
            border-radius: 0.1rem;
            position: relative;
            i {
              width: 1px;
              height: 1px;
              background-color: transparent;
              position: absolute;
              left: -0.3rem;
              top: 0.2rem;
              border-width: 0.15rem;
              border-style: solid;
              border-color: transparent #00b389 transparent transparent;
            }
          }
        }
      }
    }
  }
  .education5 {
    background-color: #f5fdfb;
    margin-top: 1rem;
    .scene {
      ul {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 0.2rem;
        li {
          width: 25%;
          text-align: center;
          padding: 0.5rem 0;
          img {
            width: 1.64rem;
          }
          span {
            display: block;
            font-size: 0.34rem;
            padding-top: 0.1rem;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/education.vue